import React from "react";
import { Col } from "reactstrap";
import { Stack } from "react-bootstrap";

export const ArabicNameFieldSkeleton = ({ colSize = "md-4" }) => {
  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <div
          className="skeleton"
          style={{ height: "20px", width: "120px" }}
        ></div>
        <div
          className="skeleton"
          style={{ height: "40px", width: "100%" }}
        ></div>
      </Stack>
    </Col>
  );
};

export const EnglishNameFieldSkeleton = ({ colSize = "md-4" }) => {
  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <div
          className="skeleton"
          style={{ height: "20px", width: "120px" }}
        ></div>
        <div
          className="skeleton"
          style={{ height: "40px", width: "100%" }}
        ></div>
      </Stack>
    </Col>
  );
};

export const MobileFieldSkeleton = ({ colSize = "md-4" }) => {
  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <div
          className="skeleton"
          style={{ height: "20px", width: "120px" }}
        ></div>
        <div className="d-flex align-items-center">
          <div
            className="skeleton"
            style={{ height: "40px", width: "100%" }}
          ></div>
        </div>
      </Stack>
    </Col>
  );
};

export const NationalityFieldSkeleton = ({ colSize = "md-4" }) => {
  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <div
          className="skeleton"
          style={{ height: "20px", width: "120px" }}
        ></div>
        <div
          className="skeleton"
          style={{ height: "40px", width: "100%" }}
        ></div>
      </Stack>
    </Col>
  );
};

export const GenderFieldSkeleton = ({ colSize = "md-4" }) => {
  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <div
          className="skeleton"
          style={{ height: "20px", width: "120px" }}
        ></div>
        <div
          className="skeleton"
          style={{ height: "40px", width: "100%" }}
        ></div>
      </Stack>
    </Col>
  );
};
